import { Action, Selector, State, StateContext } from '@ngxs/store';
import { Injectable } from '@angular/core';
import { Observable, of } from 'rxjs';
import { catchError, map } from 'rxjs/operators';
import { Error, NotificationService, CustomHttpErrorResponse } from '../../../../../common';
import { MonitoringNotificationsModel } from '../../../../models/monitoring-notification';
import { HandlingUnitNotificationsService } from './handling-unit-notifications.service';
import {
  HandlingUnitNotificationsInitialState,
  HandlingUnitNotificationsLoad,
} from './handling-unit-notifications.actions';
import { MatSnackBarRef, SimpleSnackBar } from '@angular/material/snack-bar';

export interface HandlingUnitNotificationsStateModel {
  notifications: MonitoringNotificationsModel[];
  loaded: boolean;
}

const initialState: HandlingUnitNotificationsStateModel = {
  notifications: [],
  loaded: false,
};

@State<HandlingUnitNotificationsStateModel>({
  name: 'handlingUnitNotifications',
  defaults: initialState,
})
@Injectable()
export class HandlingUnitNotificationsState {
  constructor(
    private handlingUnitNotificationsService: HandlingUnitNotificationsService,
    private notificationService: NotificationService,
  ) {}

  @Selector()
  static getLoaded(state: HandlingUnitNotificationsStateModel): boolean {
    return state.loaded;
  }

  @Selector()
  static getNotifications(state: HandlingUnitNotificationsStateModel): MonitoringNotificationsModel[] {
    return state.notifications;
  }

  @Action(HandlingUnitNotificationsLoad)
  getHandlingUnitNotifications(
    ctx: StateContext<HandlingUnitNotificationsStateModel>,
    { payload }: HandlingUnitNotificationsLoad,
  ): Observable<MatSnackBarRef<SimpleSnackBar> | void> {
    return this.handlingUnitNotificationsService.getNotifications(payload).pipe(
      map((notifications: MonitoringNotificationsModel[]) => {
        ctx.patchState({ notifications, loaded: true });
      }),
      catchError(({ error }: CustomHttpErrorResponse<Error>) => of(this.notificationService.error(error.message))),
    );
  }

  @Action(HandlingUnitNotificationsInitialState)
  setInitialState(ctx: StateContext<HandlingUnitNotificationsStateModel>): void {
    ctx.setState(initialState);
  }
}
